<div *ngIf="source !== 'simkit'" class="header" [ngClass]="{ headerHeight: source !== 'mobile', moreInfoHeaderHeight: source === 'nbnMoreInfo' }">
	<div class="close-button" (click)="close.emit()" *ngIf="source !== 'mobile'">
		<div class="cross">
			<div class="line-v"></div>
			<div class="line-h"></div>
		</div>
	</div>
	<div *ngIf="source !== 'nbnMoreInfo' && source !== 'mobile'" class="back-pattern">
		<div class="quarter-circle"><div class="circle"></div></div>
		<div class="half-circle">
			<img
				src="/assets/img/whitespots_cropped_image.png"
				class="spots-white-in-circle"
			/>
		</div>
	</div>
	<div class="header-content" [ngClass]="{'moreInfoPadding': source === 'nbnMoreInfo'}">
		<ng-content select="[header]"> </ng-content>
	</div>
</div>
<div [ngClass]="{ content: source !== 'mobile', 'content-simkit': source === 'simkit', 'content-moreInfo': source === 'nbnMoreInfo' }">
	<ng-content select="[content]"></ng-content>
</div>
